import { Injectable } from '@angular/core';
import {
  GetUserPreferenceQuery,
  GetUserPreferenceResp,
  UpsertUserPreferenceQuery,
  UpsertUserPreferenceRqst,
  UserPreferenceApiService,
} from '@xpo-ltl/sdk-userpreference';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  XpoLtlLayoutPreferencesStorage,
  XpoLtlLayoutPreferencesStorageData,
} from './layout-preferences-storage.interface';

const LAYOUT_PREFERENCE_STORAGE_KEY = 'xpoLtlLayoutPreferences';

@Injectable({
  providedIn: 'root',
})
export class XpoLtlLayoutPreferencesStorageUserPreferencesService implements XpoLtlLayoutPreferencesStorage {
  constructor(private userPreferenceService: UserPreferenceApiService) {}

  getData(): Observable<XpoLtlLayoutPreferencesStorageData> {
    const getPreferencesQuery = new GetUserPreferenceQuery();
    getPreferencesQuery.uiComponentName = LAYOUT_PREFERENCE_STORAGE_KEY;

    return this.userPreferenceService.getUserPreference(getPreferencesQuery, { loadingOverlayEnabled: false }).pipe(
      catchError((error) => of(new XpoLtlLayoutPreferencesStorageData())),
      map((result: GetUserPreferenceResp) => {
        try {
          const data = JSON.parse(result.preferences) as XpoLtlLayoutPreferencesStorageData;
          return data;
        } catch {
          return new XpoLtlLayoutPreferencesStorageData();
        }
      })
    );
  }

  setData(data: XpoLtlLayoutPreferencesStorageData): Observable<void> {
    const upsertPreferencesRequest = new UpsertUserPreferenceRqst();
    upsertPreferencesRequest.uiComponentName = LAYOUT_PREFERENCE_STORAGE_KEY;
    upsertPreferencesRequest.preferences = JSON.stringify(data);
    const upsertPreferencesQuery = new UpsertUserPreferenceQuery();
    return this.userPreferenceService.upsertUserPreference(upsertPreferencesRequest, upsertPreferencesQuery);
  }
}
